import {
  Box,
  Button,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Slide,
  Typography,
} from "@mui/material";
import React from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import CloudOutlinedIcon from "@mui/icons-material/CloudOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DoneIcon from "@mui/icons-material/Done";
import industryfiltermobile from "../../../Assets/industryfiltermobile.svg";
import decisionmakerMobileicon from "../../../Assets/decisionmakerMobileicon.svg";
import senioritymobile from "../../../Assets/senioritymobile.svg";
import locationfiltermobile from "../../../Assets/locationfiltermobile.svg";
import sidearrowmobile from "../../../Assets/sidearrowmobile.svg";
import statusmobile from "../../../Assets/statusmobile.svg";
import aiprofileiconMobile from "../../../Assets/aiprofileiconMobile.svg";
import dmakermobilefilter from "../../../Assets/dmakermobilefilter.svg";
const ProspectFilterMobile = ({
  openFilterDrawer,
  setOpenFilterDrawer,
  setOpenFilterDetail,
  openFilterDetail,
  ResetFilterData,
  filterRegion,
  handleAccordionToggle,
  isRegionSelected,
  expandedRegions,
  handleCountryChange,
  isCountrySelected,
  aidecisiondata,
  selectedData,
  handleToggleIndustry,
  showData,
  handleToggleDecisionMaker,
  selectedSeniorityData,
  handleToggleSeniority,
  lastdata,
  handleToggleJOSFStatus,
  selectedCountries,
  aiDecisionMaker,
  duplicateHandlePass,
  isTabPortrait,
  AiProfileData,
  handleAiProFIleChange,
  aiProfileList,
  handleApplyProfile,
}) => {
  return (
    <Slide
      direction="left"
      in={openFilterDrawer}
      mountOnEnter
      unmountOnExit
      className="aip-filter-mb-slide"
    >
      <Box
        sx={{
          position: "fixed",
          top: isTabPortrait ? "33px" : "0",
          left: isTabPortrait ? "" : "0",
          width: isTabPortrait ? "calc(100vw - 240px)" : "100vw",
          right: isTabPortrait ? "0px" : "",
          height: "100vh",
          bgcolor: "white",
          zIndex: 10,
          boxShadow: 2,
          display: "flex",
          flexDirection: "column",
          overflowX: "hidden",
          overflowY: "auto",
            pb: 20,

        }}
      >
        <div className="m-2">
          {/* Panel Header */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            // px={2}
            py={1.5}
          >
            {openFilterDetail ? (
              <>
                <IconButton onClick={() => setOpenFilterDetail("")}>
                  <ArrowBackIosNewIcon fontSize="small" />
                </IconButton>
                <Typography variant="subtitle1" fontWeight="bold">
                  {openFilterDetail}
                </Typography>
                <Button
                  sx={{
                    textTransform: "none",
                    color: "#0004FF",
                    fontWeight: "400",
                    fontSize: "14px",
                  }}
                  onClick={() => {
                    ResetFilterData();
                    setOpenFilterDrawer(false);
                    setOpenFilterDetail("");
                  }}
                >
                  Clear All
                </Button>
              </>
            ) : (
              <>
                <IconButton onClick={() => setOpenFilterDrawer(false)}>
                  <ArrowBackIosNewIcon fontSize="small" />
                </IconButton>
                <Typography variant="subtitle1" fontWeight="bold">
                  Filters
                </Typography>
                <Button
                  sx={{
                    textTransform: "none",
                    color: "#0004FF",
                    fontWeight: "400",
                    fontSize: "14px",
                  }}
                  onClick={() => {
                    ResetFilterData();
                    setOpenFilterDrawer(false);
                  }}
                >
                  Clear All
                </Button>
              </>
            )}
          </Box>
          <Divider />
          {/* Filter Items */}
          {openFilterDetail ? (
            <>
              {openFilterDetail === "Location" &&
              Object.keys(filterRegion)?.length ? (
                <>
                  {Object.keys(filterRegion).map((region) => (
                    <div key={region} className="leads_loc_filter_inner">
                      <div
                        className={
                          isRegionSelected(region)
                            ? "AI-leader-checkbox-and-data-list location_filter_leads_cont_2"
                            : "AI-leader-checkbox-and-data-list location_filter_leads_cont"
                        }
                      >
                        <div className="checkbox-select-data">
                          <MenuItem className="menuitems">{region}</MenuItem>
                          <span onClick={() => handleAccordionToggle(region)}>
                            <KeyboardArrowDownIcon />
                          </span>
                        </div>
                      </div>
                      {expandedRegions.includes(region) && (
                        <div className="location_filter_leads">
                          <List sx={{ width: "100%", paddingBottom: "90px" }}>
                            {filterRegion[region].map((option) => {
                              return (
                                <ListItem
                                  key={option}
                                  button
                                  onClick={() => handleCountryChange(option)}
                                  sx={{
                                    bgcolor: isCountrySelected(option)
                                      ? "#4da6ff"
                                      : "white",
                                    color: isCountrySelected(option)
                                      ? "white"
                                      : "black",
                                    "&:hover": {
                                      bgcolor: isCountrySelected(option)
                                        ? "#3399ff"
                                        : "#f5f5f5",
                                    },
                                    fontWeight: isCountrySelected(option)
                                      ? "bold"
                                      : "normal",
                                    marginBottom: "5px",
                                    borderRadius: "5px",
                                  }}
                                >
                                  <ListItemText primary={option} />
                                </ListItem>
                              );
                            })}
                            <div className="aip-mb-btn-cont">
                              <Button
                                sx={{
                                  textTransform: "none",
                                  color: "#000000",
                                  fontWeight: "600",
                                  fontSize: "14px",
                                }}
                                onClick={() => {
                                  ResetFilterData();
                                  setOpenFilterDrawer(false);
                                }}
                              >
                                Clear All
                              </Button>
                              <button
                                className="aip-apply-mb"
                                onClick={() => {
                                  duplicateHandlePass();
                                  setOpenFilterDetail("");
                                  setOpenFilterDrawer(false);
                                }}
                              >
                                <DoneIcon className="aip-mb-apply-tick-icon" />
                                <span
                                  className="mb-AileadsFilter-Apply-button"
                                  variant="contained"
                                >
                                  Apply
                                </span>
                              </button>
                            </div>
                          </List>
                        </div>
                      )}
                    </div>
                  ))}
                </>
              ) : openFilterDetail === "Industry" &&
                aidecisiondata?.data?.categories ? (
                <>
                  <List sx={{ width: "100%", paddingBottom: "90px" }}>
                    {aidecisiondata?.data?.categories.map((option) => {
                      const isSelected = selectedData.includes(option);
                      return (
                        <ListItem
                          key={option}
                          button
                          onClick={() => handleToggleIndustry(option)}
                          sx={{
                            bgcolor: isSelected ? "#4da6ff" : "white",
                            color: isSelected ? "white" : "black",
                            "&:hover": {
                              bgcolor: isSelected ? "#3399ff" : "#f5f5f5",
                            },
                            fontWeight: isSelected ? "bold" : "normal",
                            marginBottom: "5px",
                            borderRadius: "5px",
                          }}
                        >
                          <ListItemText primary={option} />
                        </ListItem>
                      );
                    })}
                    <div className="aip-mb-btn-cont">
                      <Button
                        sx={{
                          textTransform: "none",
                          color: "#000000",
                          fontWeight: "600",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          ResetFilterData();
                          setOpenFilterDrawer(false);
                        }}
                      >
                        Clear All
                      </Button>{" "}
                      <button
                        className="aip-apply-mb"
                        onClick={() => {
                          duplicateHandlePass();
                          setOpenFilterDetail("");
                          setOpenFilterDrawer(false);
                        }}
                      >
                        <DoneIcon className="aip-mb-apply-tick-icon" />
                        <span
                          className="mb-AileadsFilter-Apply-button"
                          variant="contained"
                        >
                          Apply
                        </span>
                      </button>
                    </div>
                  </List>
                </>
              ) : openFilterDetail === "Decision Maker" &&
                aidecisiondata?.data?.decision_maker ? (
                <>
                  <List sx={{ width: "100%", paddingBottom: "90px" }}>
                    {aidecisiondata?.data?.decision_maker.map((option) => {
                      const isSelected = showData.includes(option);
                      return (
                        <ListItem
                          key={option}
                          button
                          onClick={() => handleToggleDecisionMaker(option)}
                          sx={{
                            bgcolor: isSelected ? "#4da6ff" : "white",
                            color: isSelected ? "white" : "black",
                            "&:hover": {
                              bgcolor: isSelected ? "#3399ff" : "#f5f5f5",
                            },
                            fontWeight: isSelected ? "bold" : "normal",
                            marginBottom: "5px",
                            borderRadius: "5px",
                          }}
                        >
                          <ListItemText
                            primary={
                              option === "Yes"
                                ? "Decision Maker"
                                : "Non Decision Maker"
                            }
                          />
                        </ListItem>
                      );
                    })}
                    <div className="aip-mb-btn-cont">
                      <Button
                        sx={{
                          textTransform: "none",
                          color: "#000000",
                          fontWeight: "600",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          ResetFilterData();
                          setOpenFilterDrawer(false);
                        }}
                      >
                        Clear All
                      </Button>
                      <button
                        className="aip-apply-mb"
                        onClick={() => {
                          duplicateHandlePass();
                          setOpenFilterDetail("");
                          setOpenFilterDrawer(false);
                        }}
                      >
                        <DoneIcon className="aip-mb-apply-tick-icon" />
                        <span
                          className="mb-AileadsFilter-Apply-button"
                          variant="contained"
                        >
                          Apply
                        </span>
                      </button>
                    </div>{" "}
                  </List>
                </>
              ) : openFilterDetail === "Seniority" &&
                aiDecisionMaker?.data?.seniority ? (
                <>
                  <List sx={{ width: "100%", paddingBottom: "90px" }}>
                    {aiDecisionMaker?.data?.seniority.map((option) => {
                      const isSelected = selectedSeniorityData.includes(option);
                      return (
                        <ListItem
                          key={option}
                          button
                          onClick={() => handleToggleSeniority(option)}
                          sx={{
                            bgcolor: isSelected ? "#4da6ff" : "white",
                            color: isSelected ? "white" : "black",
                            "&:hover": {
                              bgcolor: isSelected ? "#3399ff" : "#f5f5f5",
                            },
                            fontWeight: isSelected ? "bold" : "normal",
                            marginBottom: "5px",
                            borderRadius: "5px",
                          }}
                        >
                          <ListItemText primary={option} />
                        </ListItem>
                      );
                    })}
                    <div className="aip-mb-btn-cont">
                      <Button
                        sx={{
                          textTransform: "none",
                          color: "#000000",
                          fontWeight: "600",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          ResetFilterData();
                          setOpenFilterDrawer(false);
                        }}
                      >
                        Clear All
                      </Button>
                      <button
                        className="aip-apply-mb"
                        onClick={() => {
                          duplicateHandlePass();
                          setOpenFilterDetail("");
                          setOpenFilterDrawer(false);
                        }}
                      >
                        <DoneIcon className="aip-mb-apply-tick-icon" />
                        <span
                          className="mb-AileadsFilter-Apply-button"
                          variant="contained"
                        >
                          Apply
                        </span>
                      </button>
                    </div>{" "}
                  </List>
                </>
              ) : openFilterDetail === "JOSF Status" &&
                aidecisiondata?.data?.josf_status ? (
                <>
                  <List sx={{ width: "100%", paddingBottom: "90px" }}>
                    {aidecisiondata?.data?.josf_status.map((option) => {
                      const isSelected = lastdata.includes(option);
                      return (
                        <ListItem
                          key={option}
                          button
                          onClick={() => handleToggleJOSFStatus(option)}
                          sx={{
                            bgcolor: isSelected ? "#4da6ff" : "white",
                            color: isSelected ? "white" : "black",
                            "&:hover": {
                              bgcolor: isSelected ? "#3399ff" : "#f5f5f5",
                            },
                            fontWeight: isSelected ? "bold" : "normal",
                            marginBottom: "5px",
                            borderRadius: "5px",
                          }}
                        >
                          <ListItemText primary={option} />
                        </ListItem>
                      );
                    })}
                    <div className="aip-mb-btn-cont">
                      <Button
                        sx={{
                          textTransform: "none",
                          color: "#000000",
                          fontWeight: "600",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          ResetFilterData();
                          setOpenFilterDrawer(false);
                        }}
                      >
                        Clear All
                      </Button>
                      <button
                        className="aip-apply-mb"
                        onClick={() => {
                          duplicateHandlePass();
                          setOpenFilterDetail("");
                          setOpenFilterDrawer(false);
                        }}
                      >
                        <DoneIcon className="aip-mb-apply-tick-icon" />
                        <span
                          className="mb-AileadsFilter-Apply-button"
                          variant="contained"
                        >
                          Apply
                        </span>
                      </button>
                    </div>
                  </List>
                </>
              ) : openFilterDetail === "AI Profile" && aiProfileList?.length ? (
                <>
                  <List sx={{ width: "100%", paddingBottom: "90px" }}>
                    {aiProfileList.map((item) => {
                      const isSelected = AiProfileData === item.name;

                      return (
                        <ListItem
                          key={item.id}
                          button
                          onClick={() => {
                            handleAiProFIleChange({
                              target: { value: item.name },
                            });
                          }}
                          sx={{
                            bgcolor: isSelected ? "#4da6ff" : "white",
                            color: isSelected ? "white" : "black",
                            "&:hover": {
                              bgcolor: isSelected ? "#3399ff" : "#f5f5f5",
                            },
                            fontWeight: isSelected ? "bold" : "normal",
                            marginBottom: "5px",
                            borderRadius: "5px",
                          }}
                        >
                          <ListItemText primary={item.name} />
                        </ListItem>
                      );
                    })}

                    <div className="aip-mb-btn-cont">
                      <Button
                        sx={{
                          textTransform: "none",
                          color: "#000000",
                          fontWeight: "600",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          ResetFilterData();
                          setOpenFilterDrawer(false);
                        }}
                      >
                        Reset
                      </Button>

                      <button
                        className="aip-apply-mb"
                        onClick={() => {
                          const selectedItem = aiProfileList.find(
                            (profile) => profile.name === AiProfileData,
                          );

                          if (selectedItem) {
                            handleApplyProfile(selectedItem);
                          }

                          setOpenFilterDetail("");
                          setOpenFilterDrawer(false);
                        }}
                      >
                        <DoneIcon className="aip-mb-apply-tick-icon" />
                        <span className="mb-AileadsFilter-Apply-button">
                          Apply
                        </span>
                      </button>
                    </div>
                  </List>
                </>
              ) : null}
            </>
          ) : (
            <List>
              <ListItem
                style={{ borderBottom: "1px solid #C8C9C7" }}
                button
                secondaryAction={
                  <Box display="flex" alignItems="center" gap={1}>
                    {selectedCountries?.length ? (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        fontSize="1rem"
                      >
                        {selectedCountries?.length} Selected
                      </Typography>
                    ) : null}
                    <img src={sidearrowmobile} alt="" />{" "}
                  </Box>
                }
                onClick={() => {
                  setOpenFilterDetail("Location");
                }}
              >
                <ListItemIcon style={{ minWidth: "30px" }}>
                  <img src={locationfiltermobile} alt="" />
                </ListItemIcon>
                <ListItemText primary="Location" />
              </ListItem>

              <ListItem
                button
                style={{ borderBottom: "1px solid #C8C9C7" }}
                secondaryAction={
                  <Box display="flex" alignItems="center" gap={1}>
                    {selectedData?.length ? (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        fontSize="1rem"
                      >
                        {selectedData?.length} Selected
                      </Typography>
                    ) : null}
                    <img src={sidearrowmobile} alt="" />{" "}
                  </Box>
                }
                onClick={() => {
                  setOpenFilterDetail("Industry");
                }}
              >
                <ListItemIcon style={{ minWidth: "30px" }}>
                  <img src={industryfiltermobile} alt="" />
                </ListItemIcon>
                <ListItemText primary="Industry" />
              </ListItem>

              <ListItem
                button
                style={{ borderBottom: "1px solid #C8C9C7" }}
                secondaryAction={
                  <Box display="flex" alignItems="center" gap={1}>
                    {showData?.length ? (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        fontSize="1rem"
                      >
                        {showData?.length} Selected
                      </Typography>
                    ) : null}
                    <img src={sidearrowmobile} alt="" />{" "}
                  </Box>
                }
                onClick={() => {
                  setOpenFilterDetail("Decision Maker");
                }}
              >
                <ListItemIcon style={{ minWidth: "30px" }}>
                  {/* <img src={decisionmakerMobileicon} alt="" /> */}
                  <img src={dmakermobilefilter} alt="" />
                </ListItemIcon>
                <ListItemText primary="Decision Maker" />
              </ListItem>

              <ListItem
                button
                style={{ borderBottom: "1px solid #C8C9C7" }}
                secondaryAction={
                  <Box display="flex" alignItems="center" gap={1}>
                    {selectedSeniorityData?.length ? (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        fontSize="1rem"
                      >
                        {selectedSeniorityData?.length} Selected
                      </Typography>
                    ) : null}
                    <img src={sidearrowmobile} alt="" />{" "}
                  </Box>
                }
                onClick={() => {
                  setOpenFilterDetail("Seniority");
                }}
              >
                <ListItemIcon style={{ minWidth: "30px" }}>
                  <img src={senioritymobile} alt="" />{" "}
                </ListItemIcon>
                <ListItemText primary="Seniority" />
              </ListItem>

              <ListItem
                button
                secondaryAction={
                  <Box display="flex" alignItems="center" gap={1}>
                    {lastdata?.length ? (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        fontSize="1rem"
                      >
                        {lastdata?.length} Selected
                      </Typography>
                    ) : null}
                    <img src={sidearrowmobile} alt="" />{" "}
                  </Box>
                }
                onClick={() => {
                  setOpenFilterDetail("JOSF Status");
                }}
              >
                <ListItemIcon style={{ minWidth: "30px" }}>
                  <img src={statusmobile} alt="" />{" "}
                </ListItemIcon>
                <ListItemText primary="JOSF Status" />
              </ListItem>

              <ListItem
                button
                secondaryAction={
                  <Box display="flex" alignItems="center" gap={1}>
                    {AiProfileData ? (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        fontSize="1rem"
                      >
                        1 Selected
                      </Typography>
                    ) : null}
                    <img src={sidearrowmobile} alt="" />{" "}
                  </Box>
                }
                onClick={() => {
                  setOpenFilterDetail("AI Profile");
                }}
              >
                <ListItemIcon style={{ minWidth: "30px" }}>
                  <img src={aiprofileiconMobile} alt="" />
                </ListItemIcon>
                <ListItemText primary="AI Profile" />
              </ListItem>
            </List>
          )}
          {/* {openFilterDetail ? null : (
            <div className="aip-mb-btn-cont">
              <button
                className="aip-apply-mb"
                onClick={() => {
                  duplicateHandlePass();
                  setOpenFilterDetail("");
                  setOpenFilterDrawer(false);
                }}
              >
                <DoneIcon className="aip-mb-apply-tick-icon" />
                <span
                  className="mb-AileadsFilter-Apply-button"
                  variant="contained"
                >
                  Apply
                </span>
              </button>
            </div>
          )}{" "} */}
          {/* <div className='aip-mb-btn-cont'>
                        <button
                            className="aip-apply-mb"
                            onClick={() => { duplicateHandlePass(); setOpenFilterDetail(""); setOpenFilterDrawer(false) }}
                        >
                            <DoneIcon className="aip-mb-apply-tick-icon" />
                            <span className="mb-AileadsFilter-Apply-button" variant="contained">
                                Apply
                            </span>
                        </button>
                    </div> */}
        </div>
      </Box>
    </Slide>
  );
};

export default ProspectFilterMobile;
